import AccessDenied from "./AccessDenied";
import DecryptData from "./Decrypt";

export function GetAccess(accessText) {
  if (GetRole()) {
    return true;
  } else {
    const userAccess = localStorage.getItem("sSeCcArEsUeDaRt")
      ? DecryptData("sSeCcArEsUeDaRt")
      : [];
    const access = userAccess
      ? userAccess.some((permission) => permission.permissionName == accessText)
      : false;
    return access;
  }
}

export function GetMultipleAccess(accessTextArr = []) {
  if (GetRole()) {
    return true;
  } else {
    const userAccess = localStorage.getItem("sSeCcArEsUeDaRt")
      ? DecryptData("sSeCcArEsUeDaRt")
      : [];
    const access = accessTextArr.some((element) =>
      userAccess.some((userObj) => userObj.permissionName === element),
    );
    return access;
  }
}

export function GetRole() {
  const userData = localStorage.getItem("sLiAtEdReSuEdArT")
    ? DecryptData("sLiAtEdReSuEdArT")
    : [];
  const role = userData?.role ? String(userData.role).trim().toLowerCase() : "";
  if (role === "super admin" || role === "admin") {
    return true;
  } else {
    return false;
  }
}

export function GetMultiRole(roles = []) {
  if (GetRole()) {
    return true;
  } else {
    const userData = localStorage.getItem("sLiAtEdReSuEdArT")
      ? DecryptData("sLiAtEdReSuEdArT")
      : [];
    const role = userData?.role ? String(userData.role).trim().toLowerCase() : "";
    const normalizedRoles = roles.map((r) => String(r).trim().toLowerCase());
    if (normalizedRoles.includes(role)) {
      return true;
    } else {
      return false;
    }
  }
}

export function GetDashboardRole(giveRole = "") {
  // const encryptedUserData = localStorage.getItem("sLiAtEdReSuEdArT");
  const userData = localStorage.getItem("sLiAtEdReSuEdArT")
    ? DecryptData("sLiAtEdReSuEdArT")
    : [];
  const role = userData?.role ? String(userData.role).trim().toLowerCase() : "";
  const normalizedGiveRole = String(giveRole).trim().toLowerCase();
  if (role === "super admin" || role === "admin") {
    return true;
  } else if (role === normalizedGiveRole) {
    return true;
  } else {
    return false;
  }
}

export function GetNotUseRole(giveRole = "") {
  // const encryptedUserData = localStorage.getItem("sLiAtEdReSuEdArT");
  const userData = localStorage.getItem("sLiAtEdReSuEdArT")
    ? DecryptData("sLiAtEdReSuEdArT")
    : [];
  const role = userData?.role ? String(userData.role).trim().toLowerCase() : "";
  const normalizedGiveRole = String(giveRole).trim().toLowerCase();
  console.log("role", role);

  if (role === "super admin" || role === "admin") {
    return true;
  } else if (role === normalizedGiveRole) {
    return false;
  } else {
    return true;
  }
}

export function GetMultiNotUseRole(giveRoles = []) {
  const userData = localStorage.getItem("sLiAtEdReSuEdArT")
    ? DecryptData("sLiAtEdReSuEdArT")
    : [];

  const role = userData?.role ? String(userData.role).trim().toLowerCase() : "";
  const normalizedGiveRoles = giveRoles.map((r) => String(r).trim().toLowerCase());

  return (
    role === "super admin" || role === "admin" || !normalizedGiveRoles.includes(role)
  );
}

export function RendorPage(accessKey, Component) {
  if ((GetRole() || GetAccess(accessKey)) == true) {
    return <Component />;
  } else {
    return <AccessDenied />;
  }
}

export function Wrapper({ accessKey, permissionKey, Component }) {
  return RendorPage(permissionKey || accessKey, Component);
}

export function GetSuperAdminRole() {
  const userData = localStorage.getItem("sLiAtEdReSuEdArT")
    ? DecryptData("sLiAtEdReSuEdArT")
    : null;
  const role = userData?.role ? String(userData.role).trim().toLowerCase() : "";
  return role === "super admin";
}

export function SuperAdminWrapper({ Component }) {
  if (GetSuperAdminRole()) {
    return <Component />;
  } else {
    return <AccessDenied />;
  }
}

export function GetUserDetail() {
  let name = "";
  let role = "";
  const userData = localStorage.getItem("sLiAtEdReSuEdArT")
    ? DecryptData("sLiAtEdReSuEdArT")
    : [];
  console.log("userData", userData);

  name = userData?.name;
  role = userData?.role ? String(userData.role).trim().toLowerCase() : "";
  const id = userData?.id;
  return { name, role, id };
}

export function CheckEditAction(row, moduleName = "", canEdit = false) {
  const statusStr = String(row?.approvalStatus || row?.status || "").trim().toLowerCase();
  const isApprovedOrVerified = statusStr === "approved" || statusStr === "verified";
  
  if (isApprovedOrVerified) {
    const mod = String(moduleName || "").trim().toLowerCase();
    if (mod === "purchase order" || mod === "ypr" || mod === "po") {
      return canEdit;
    }
    return GetRole();
  }
  return canEdit;
}

export function CheckDeleteAction(row, canDelete = false) {
  const statusStr = String(row?.approvalStatus || row?.status || "").trim().toLowerCase();
  const isApprovedOrVerified = statusStr === "approved" || statusStr === "verified";
  
  if (isApprovedOrVerified) {
    return GetRole();
  }
  return canDelete;
}

